import { useAuthAxiosInterceptors } from "@turbozaim/auth-service-client";
import axios from "axios";
import { redirect } from "../helpers/redirect";
import { AuthActionCreators } from "../store/action-creators";
// eslint-disable-next-line import/no-cycle
import { store } from "../store/store";
import { createAxiosInstance } from "./createAxiosInstance";

const instance = createAxiosInstance();

export const removeAuth = () => {
  localStorage.removeItem("turbo-zaim-state");
  store.dispatch(AuthActionCreators.setIsAuth(false));
};

const redirectToLk = (response) => {
  // eslint-disable-next-line no-console
  console.log("redirectToLk", response);
  redirect(response.data.redirectToLk);
};

useAuthAxiosInterceptors({
  axiosInstance: instance,
});

instance.interceptors.response.use(undefined, async (error) => {
  if (axios.isCancel(error)) {
    // Игнорируем ошибки отмены запроса
    return error;
  }
  if (error.code === "ERR_NETWORK" && !instance.networkError) {
    instance.networkError = true;
    // eslint-disable-next-line no-console
    console.error(
      "Не удалось соединиться с бэкендом.\nПроверьте настройки подключения к бэкенду"
    );
  }
  if (!error) {
    instance.networkError = false;
  }

  // Запрос не авторизован, потому что не удалось сделать рефреш
  // Ошибка отмены запроса не имеет error.response
  if (error.response?.status === 401) {
    removeAuth();
    window.location.href = "/authorization";
  }
  // Ошибка: заявка в неверном статусе
  if (error.response?.status === 405) {
    redirectToLk(error.response);
  }
  throw error;
});

export const getAxios = () => instance;
